import api from '../../../../../api/client';
import { REPORT } from '../../../../../api/endpoints';

// ── Export Bidders Report (PDF or Excel)
export async function exportTransactionsReport({
  params = {},
  fileType,
  fileName = 'Transactions_Report',
}) {
  try {
    const response = await api.get(REPORT.TRANSACTIONS_NEW_EXPORT, {
      params,
      responseType: 'blob', //  token + lang injected automatically by interceptor
    });

    const config = {
      pdf: { mime: 'application/pdf', ext: '.pdf' },
      excel: {
        mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        ext: '.xlsx',
      },
    };

    const { mime, ext } = config[fileType] ?? {};
    if (!mime) throw new Error(`Unsupported fileType: ${fileType}`);

    // Resolve filename from Content-Disposition or fallback
    const contentDisposition = response.headers['content-disposition'];
    let filename = contentDisposition
      ? contentDisposition.split('filename=')[1]?.replace(/"/g, '').trim()
      : `${fileName}_${Date.now()}${ext}`;

    if (!filename.endsWith(ext)) filename += ext;

    // Trigger browser download
    const blob = new Blob([response.data], { type: mime });
    const blobUrl = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(blobUrl);

    return { success: true };
  } catch (error) {
    console.error('Export error:', error);
    return { success: false, error };
  }
}

export async function exportBidderPaymentReport({
  params = {},
  fileType,
  fileName = 'Transactions_Report',
}) {
  try {
    const response = await api.get(REPORT.AUCTION_PAYMENT_BIDDER_EXPORT, {
      params,
      responseType: 'blob', //  token + lang injected automatically by interceptor
    });

    const config = {
      pdf: { mime: 'application/pdf', ext: '.pdf' },
      excel: {
        mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        ext: '.xlsx',
      },
    };

    const { mime, ext } = config[fileType] ?? {};
    if (!mime) throw new Error(`Unsupported fileType: ${fileType}`);

    // Resolve filename from Content-Disposition or fallback
    const contentDisposition = response.headers['content-disposition'];
    let filename = contentDisposition
      ? contentDisposition.split('filename=')[1]?.replace(/"/g, '').trim()
      : `${fileName}_${Date.now()}${ext}`;

    if (!filename.endsWith(ext)) filename += ext;

    // Trigger browser download
    const blob = new Blob([response.data], { type: mime });
    const blobUrl = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(blobUrl);

    return { success: true };
  } catch (error) {
    console.error('Export error:', error);
    return { success: false, error };
  }
}

export async function exportClientPaymentReport({
  params = {},
  fileType,
  fileName = 'Transactions_Report',
}) {
  try {
    const response = await api.get(REPORT.AUCTION_PAYMENT_CLIENT_EXPORT, {
      params,
      responseType: 'blob', //  token + lang injected automatically by interceptor
    });

    const config = {
      pdf: { mime: 'application/pdf', ext: '.pdf' },
      excel: {
        mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        ext: '.xlsx',
      },
    };

    const { mime, ext } = config[fileType] ?? {};
    if (!mime) throw new Error(`Unsupported fileType: ${fileType}`);

    // Resolve filename from Content-Disposition or fallback
    const contentDisposition = response.headers['content-disposition'];
    let filename = contentDisposition
      ? contentDisposition.split('filename=')[1]?.replace(/"/g, '').trim()
      : `${fileName}_${Date.now()}${ext}`;

    if (!filename.endsWith(ext)) filename += ext;

    // Trigger browser download
    const blob = new Blob([response.data], { type: mime });
    const blobUrl = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(blobUrl);

    return { success: true };
  } catch (error) {
    console.error('Export error:', error);
    return { success: false, error };
  }
}

export async function exportUserReport({
  params = {},
  fileType,
  fileName = 'Transactions_Report',
}) {
  try {
    const response = await api.get(REPORT.USERS_EXPORT, {
      params,
      responseType: 'blob', //  token + lang injected automatically by interceptor
    });

    const config = {
      pdf: { mime: 'application/pdf', ext: '.pdf' },
      excel: {
        mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        ext: '.xlsx',
      },
    };

    const { mime, ext } = config[fileType] ?? {};
    if (!mime) throw new Error(`Unsupported fileType: ${fileType}`);

    // Resolve filename from Content-Disposition or fallback
    const contentDisposition = response.headers['content-disposition'];
    let filename = contentDisposition
      ? contentDisposition.split('filename=')[1]?.replace(/"/g, '').trim()
      : `${fileName}_${Date.now()}${ext}`;

    if (!filename.endsWith(ext)) filename += ext;

    // Trigger browser download
    const blob = new Blob([response.data], { type: mime });
    const blobUrl = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(blobUrl);

    return { success: true };
  } catch (error) {
    console.error('Export error:', error);
    return { success: false, error };
  }
}
